import Vue from 'vue'

Vue.filter('PBA', (value: any) => {
    if (value == 1)
        return "level I";
    else if (value == 2)
        return "level II";
    else if (value == 3)
        return "level III";
    else
        return "";
})

Vue.filter('currency', (value: number, symbol: string) => {
    return "".concat(symbol, value.toLocaleString());
})

Vue.filter('utc', (value: Date) => {
    return Vue.prototype.$moment.utc(value);
});

Vue.filter('timezone', (value: Date) => {
    return Vue.prototype.$moment.utc(value).local();
})
